import { useEffect } from "react";
import { getCandidate } from "@/lib/scoutApi";

/** Poll a candidate every 6s while `active`; call onDone(fresh) once `field` leaves "building". */
export const usePollCandidate = (id, active, field, onDone) => {
  useEffect(() => {
    if (!active) return undefined;
    const t = setInterval(async () => {
      try {
        const fresh = await getCandidate(id);
        if (fresh[field] !== "building") {
          clearInterval(t);
          onDone(fresh);
        }
      } catch (err) {
        console.warn(`Polling ${field} for ${id} failed; retrying`, err?.message || err);
      }
    }, 6000);
    return () => clearInterval(t);
  }, [id, active, field, onDone]);
};
